import { useCreateOrUpdateCollectorInMultipleprint } from "@/api/related-fields";
import { LinkableType } from "@/components/LinksManagement";
import { FieldConfig } from "@/config/forms/general";
import { CollectorInMultipleprint } from "@/lib/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import LinksDrawerLayout from "./LinksDrawerLayout";

const CollectorInMultipleprintDrawer = ({
  fields,
  data,
  queryId,
  type,
}: {
  fields: FieldConfig[] | undefined;
  data: CollectorInMultipleprint;
  queryId: string;
  type: LinkableType;
}) => {
  const schema = z.object({
    estampesDansCollectionneursDescriptionInfos: z.string().optional(),
  });

  const { mutate: createOrUpdateCollectorInMultipleprint } =
    useCreateOrUpdateCollectorInMultipleprint(queryId, type);

  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
    defaultValues: {
      estampesDansCollectionneursDescriptionInfos:
        data.estampesDansCollectionneursDescriptionInfos,
    },
  });

  const onSubmit = (formData: z.infer<typeof schema>) => {
    createOrUpdateCollectorInMultipleprint({
      id: data.id,
      collectorId: data.collector.id,
      multipleprintId: data.multipleprint.id,
      ...formData,
    });
  };

  return (
    <LinksDrawerLayout
      form={form}
      fields={fields ?? []}
      recordId={data.id}
      onSubmit={onSubmit}
    />
  );
};

export default CollectorInMultipleprintDrawer;
